(function(){
  // prova a ricavare il section.id dal <template>
  var tpl = document.querySelector('[id^="variant-bottles-map-"]');
  if(!tpl) return;
  var secId = tpl.id.replace('variant-bottles-map-','');

  // leggi mappa variantId -> stringa bottiglie
  var json = tpl.innerHTML || tpl.textContent || '{}';
  var bottlesMap = {};
  try { bottlesMap = JSON.parse(json) || {}; } catch(e) {}

  var rowEl   = document.getElementById('bottles-row-' + secId);
  var valueEl = document.getElementById('bottles-value-' + secId);
  if(!rowEl || !valueEl) return;

  function setBottles(variantId){
    var val = bottlesMap[String(variantId)] || '';
    if(!val || String(val).trim() === ''){
      rowEl.style.display = 'none';
      valueEl.textContent = '';
    } else {
      rowEl.style.display = '';
      valueEl.textContent = String(val);
    }
  }

  // 1) evento nativo dei temi moderni (Split/Dawn)
  document.addEventListener('variant:change', function(e){
    var v = e.detail && e.detail.variant;
    if(v && v.id) setBottles(v.id);
  });

  // 2) fallback: ascolta cambi nel form varianti
  var form = document.querySelector('form[action*="/cart/add"]');
  if(form){
    form.addEventListener('change', function(){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      var variantId = (idInput && idInput.value) || (select && select.value);
      if(variantId) setBottles(variantId);
    });

    // alcuni temi sostituiscono l’input id dinamicamente
    new MutationObserver(function(){
      var idInput = form.querySelector('input[name="id"]');
      if(idInput && idInput.value) setBottles(idInput.value);
    }).observe(form, {subtree:true, childList:true});
  }

  // 3) init con la variante corrente
  (function(){
    var initialId = null;
    if(form){
      var idInput = form.querySelector('input[name="id"]');
      var select  = form.querySelector('select[name="id"]');
      initialId = (idInput && idInput.value) || (select && select.value);
    }
    if(!initialId){
      var keys = Object.keys(bottlesMap);
      if(keys.length) initialId = keys[0];
    }
    if(initialId) setBottles(initialId);
  })();
})();